import { OnInit } from '@angular/core';
import { BillboardService } from '../billboard-service/billboard.service';
import { EventsService } from '../../core/services/events-service/events.service';
var LiveComponent = /** @class */ (function () {
    function LiveComponent(billboardService, eventService) {
        this.billboardService = billboardService;
        this.eventService = eventService;
        this.eventData = null;
        this.billboard = null;
        this.time = 0;
    }
    LiveComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getEventData();
        this.getBillboardData();
        setInterval(function () {
            _this.tick();
        }, 1000);
    };
    LiveComponent.prototype.tick = function () {
        this.time++;
        if (this.time % 60 === 0) {
            this.getBillboardData();
        }
    };
    Object.defineProperty(LiveComponent.prototype, "countdown", {
        get: function () {
            return 60 - (this.time % 60);
        },
        enumerable: true,
        configurable: true
    });
    LiveComponent.prototype.getEventData = function () {
        var _this = this;
        this.eventService.getEvent('jki30th').subscribe(function (res) {
            _this.eventData = res;
        }, function (err) {
            console.log('err =', err);
        });
    };
    LiveComponent.prototype.bracketLink = function (groupNumber) {
        var fix_me = 'jki30th';
        return "/api/v1/events/" + fix_me + "/groups/" + groupNumber;
    };
    LiveComponent.prototype.getBillboardData = function () {
        var _this = this;
        this.billboardService.getBillboardData().subscribe(function (res) {
            _this.billboard = res;
        }, function (err) {
            console.log('err =', err);
        });
    };
    return LiveComponent;
}());
export { LiveComponent };
